import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { TappingManualCheckListReport } from './Pages/listing';

export const TappingManualCheckListReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={TappingManualCheckListReport} />
    </Fragment>
)